<template>
  <basic-container>
    <div class="qualiify-container">
      <!-- banner -->
      <div class="banner_w3lspvt-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" aria-current="page">
            {{ $t("qat.title") }}
          </li>
        </ol>
      </div>

      <!-- //main banner -->
      <!-- stats -->
      <div class="qat_process">
        <h3
          class="tittle text-center font-weight-bold"
          style="margin-bottom: 2rem"
        >
          {{ $t("qat.subTitle") }}
        </h3>
        <div class="new_container_">
          <div class="process_content-wrapper">
            <div class="process-item">
              <div class="process-item-icon">
                <img src="@/assets/images/targeting1.svg" alt="" />
              </div>
              <div class="process-item-title">{{ $t("qat.li1") }}</div>
            </div>

            <div class="process-item">
              <div class="process-item-icon">
                <img src="@/assets/images/targeting2.svg" alt="" />
              </div>
              <div class="process-item-title">
                {{ $t("qat.li2") }}
              </div>
            </div>

            <div class="process-item">
              <div class="process-item-icon">
                <img src="@/assets/images/targeting3.svg" alt="" />
              </div>
              <div class="process-item-title">{{ $t("qat.li3") }}</div>
            </div>

            <div class="process-item">
              <div class="process-item-icon">
                <img src="@/assets/images/targeting4.svg" alt="" />
              </div>
              <div class="process-item-title">{{ $t("qat.li4") }}</div>
            </div>

            <div class="process-item">
              <div class="process-item-icon">
                <img src="@/assets/images/targeting4.svg" alt="" />
              </div>
              <div class="process-item-title">
                {{ $t("qat.li5") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container py-xl-5 py-lg-3">
        <h4 style="margin-bottom: 20px">{{ $t("qat.content") }}</h4>
        <p style="margin-bottom: 40px">{{ $t("qat.content2") }}</p>
      </div>
    </div>
    <LogoComponent></LogoComponent>
  </basic-container>
</template>

<script>
import LogoComponent from "@/components/commonComponents/logoComponent";

export default {
  components: { LogoComponent },

  name: "index",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .process_content-wrapper {
    width: 100%;
    flex-direction: column;
    .process-item {
    width: 100%;
    margin-top: 15px;
  }
  }
  
}
</style>
